import amplitude from "amplitude-js";

const IS_AMPLITUDE_ACTIVATE = process.env.REACT_APP_AMPLITUDE_ACTIVATE;
// console.log("activate->",IS_AMPLITUDE_ACTIVATE);

export const logAmplitudeEventWithUsernameAndRole = (eventName, eventProps, username) => {
	if(IS_AMPLITUDE_ACTIVATE === "true"){
		try{
			let amplitudeInstance = amplitude.getInstance();
			amplitudeInstance.setUserId(username);			
			amplitudeInstance.logEvent(eventName, eventProps);
		}catch(err){
			console.error('Failed to log amplitude event duw to following error !', err);
		}
	}
}

export const logAmplitudeUserProperties = (userProps, username) => {
	if(IS_AMPLITUDE_ACTIVATE === "true"){
	    try {
			let amplitudeInstance = amplitude.getInstance();
	        amplitudeInstance.setUserId(username);
	        amplitudeInstance.setUserProperties(userProps);
	    } catch (err) {
	        console.error('Failed to log amplitude event due to following error !', err);
	    }
	}
}